import React, { Component } from 'react';
import LoaderWrapper from '../../../../Components-2025/QuestionBank/LoaderWrapper';
import ReadingList from '../../../../Components-2025/QuestionBank/ReadingList';
import ComponentHeader from '../../../../common/ComponentHeader';
import CustomButton from '../../../../common/CustomButton';
import { messages } from '../../../../common/messages';
import ModalComponent from '../../../Common/Modal';
import PDFModelComponent from '../../../Common/PDFModel';
import alertMessage from '../../../config/alertMessage';
import apiServiceProvider from './ApiService';
import appRoutes from '../../../config/AppRoutes';
import { TotalQuestionCountKey, chapterNameKey, freeQuestionCountKey } from './ApiAttributesKays';
import { showInformation } from '../../../../common/toast';

export default class ReadingsList extends Component {
  static contextTypes = { router: React.PropTypes.object };
  constructor(props) {
    super(props);
    this.state = {
      selectedExamSubscriptionDetails: {},
      chapterName: '',
      pdfAlert: false,
      openPremiumPopup: false,
      isUserSubscribed: false,
      readingListData: [],
      isLoading: true,
    };
  }

  async componentDidMount() {
    const { chapterId, level } = this.props.params;
    const fetchReadingListData = await apiServiceProvider['fetchReadingList']({ chapterId });
    if (fetchReadingListData.success) {
      const { readings, selectedExamSubscriptionDetails } = fetchReadingListData;
      if (Object.keys(selectedExamSubscriptionDetails).length) {
        if (
          selectedExamSubscriptionDetails.subscriptionDetailsForFrm1And2 ||
          selectedExamSubscriptionDetails[`subscriptionDetailsForFrm${level}`]
        )
          this.setState({ isUserSubscribed: true });
      }
      this.setState({
        readingListData: readings,
        selectedExamSubscriptionDetails,
        isLoading: false,
        chapterName: fetchReadingListData.chapterName[chapterNameKey],
      });
    }
    this.setState({ isLoading: false });
  }
  checkSubscription = async (cb, type) => {
    const { isUserSubscribed } = this.state;
    if (!isUserSubscribed) {
      return this.setState({ openPremiumPopup: true });
    }
    cb();
    this.setState({ PDFDownloadType: type });
    this.pdfAlertModel();
  };

  goPremium = () => {
    const { router } = this.context;
    router.push({ pathname: '/Subscribe' });
  };
  toggleAlert = () => {
    this.setState({ openPremiumPopup: !this.state.openPremiumPopup });
  };
  pdfAlertModel = () => {
    this.setState({ pdfAlert: !this.state.pdfAlert });
  };
  onViewList = items => {
    const {
      params: { level },
    } = this.props;
    const { isUserSubscribed } = this.state;
    if (!isUserSubscribed && items[freeQuestionCountKey] === 0) {
      return this.setState({ openPremiumPopup: true });
    } else {
      if (!items[TotalQuestionCountKey]) {
        showInformation(messages.QUESTION_NOT_AVAILABLE_FOR_READING);
      } else {
        const { router } = this.context;

        router.push({
          pathname: appRoutes.FRM_V2_QUESTION_BANK_QUESTION_LIST.replace(':level', level).replace(
            ':readingId',
            items.id,
          ),
        });
      }
    }
  };
  onBeginChapter = items => {
    const { isUserSubscribed } = this.state;
    if (!isUserSubscribed && items[freeQuestionCountKey] === 0) {
      return this.setState({ openPremiumPopup: true });
    } else {
      if (!items[TotalQuestionCountKey]) {
        showInformation(messages.QUESTION_NOT_AVAILABLE_FOR_READING);
      } else {
        const { router } = this.context;

        router.push({
          pathname: appRoutes.FRM_V2_QUESTION_BANK_QUESTION_VIEW.replace(
            ':level',
            items.level,
          ).replace(':readingId', items.id),
        });
      }
    }
  };
  render() {
    const { params } = this.props;
    const { chapterId, level } = params;
    const {
      chapterName,
      pdfAlert,
      openPremiumPopup,
      isUserSubscribed,
      readingListData,
      isLoading = false,
    } = this.state;
    const { router } = this.context;

    return (
      <div className='animated fadeIn'>
        {/* //* ============================{{ HEADER START HERE }}========================================== */}
        <ComponentHeader title={`${chapterId}. ${chapterName}`}>
          <div className='download-pdf-button'>
            <CustomButton
              className='bg-completed-cases overflow-hidden max-width-min-content'
              onClick={() => {
                this.checkSubscription(
                  () =>
                    apiServiceProvider['pdfDownloadViaEmail']({
                      pdfType: 'question',
                      chapterId,
                      level,
                    }),
                  'Question',
                );
              }}
            >
              <i className='fa fa-download pr-1' aria-hidden='true' />
              {!isUserSubscribed && <div className='premium-download'>Premium</div>}
              {messages.DOWNLOAD_QUESTION}
            </CustomButton>
            <CustomButton
              className='bg-completed-cases overflow-hidden max-width-min-content'
              onClick={() => {
                this.checkSubscription(
                  () =>
                    apiServiceProvider['pdfDownloadViaEmail']({
                      pdfType: 'questionAnswer',
                      chapterId,
                      level,
                    }),
                  'Question/Answer',
                );
              }}
            >
              <i className='fa fa-download pr-1' aria-hidden='true' />
              {!isUserSubscribed && <div className='premium-download'>Premium</div>}
              {messages.DOWNLOAD_QUESTION_ANSWER}
            </CustomButton>
            <CustomButton onClick={() => router.push({ pathname: appRoutes.FRM_V2_QUESTION_BANK })}>
              {messages.CHANGE_TOPIC}
            </CustomButton>
          </div>
        </ComponentHeader>
        {/* //* ============================{{ HEADER ENDED HERE }}========================================== */}
        <LoaderWrapper isLoading={isLoading}>
          <ReadingList
            readingData={readingListData}
            tableName={messages.CHAPTER_READING}
            onViewList={this.onViewList}
            onBeginChapter={this.onBeginChapter}
          />
        </LoaderWrapper>
        {/* //* THIS IS FOR PREMIUM POPUP  */}
        <ModalComponent
          goPremium={this.goPremium}
          toggleAlert={this.toggleAlert}
          alert_status={openPremiumPopup}
          MessageContent={alertMessage.messageContent_frm}
          exam={'FRM'}
        />

        {/* //* THIS IS PDF DOWNLOAD SUCCESS MODAL POP-UP  */}
        <PDFModelComponent
          type={'Question'}
          pdfAlertModel={this.pdfAlertModel}
          pdfAlert={pdfAlert}
          PDFContentMessage={messages.PDF_DOWNLOAD_CONTENT_MESSAGE}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/FRM-V2/Questionbank/QuestionReadingList/ReadingsList.jsx